import { type Factiii } from '@shared/all/domains/factiiis';

import { type WrappedTRPCClient } from '../helpers/trpcClientTypes';
import useFactiiis from './useFactiiis';
import usePinnedFactiiis from './usePinnedFactiiis';

const usePinUserFactiii = (client: WrappedTRPCClient) => {
  const { invalidate } = usePinnedFactiiis(client);
  const { initializeFactiiis } = useFactiiis(client);

  // Only the id is sent, so any factiii shape (Factiii, PinnedFactiii, a search
  // hit) can be pinned without remapping it first.
  const pinUserFactiii = async (
    factiii: Pick<Factiii, 'id'>,
    spaceSlug?: string
  ) => {
    const [error, result] = await client.factiiis.pin.mutate({
      type: 'USER',
      factiiiId: factiii.id,
      spaceSlug
    });
    if (error) return [error, undefined] as const;
    const isPinned = result?.status === 'PINNED';
    await invalidate();
    // Pins are unioned into the initialItems set server-side, so the factiii
    // pool — and the copy stored for the next launch — are both stale now.
    void initializeFactiiis();
    return [undefined, isPinned] as const;
  };

  return pinUserFactiii;
};

export default usePinUserFactiii;
